module.exports = __webpack_public_path__ + "assets/img/ebc6abd60ae49d3acf9c8f26b373d2c1.svg";